import { isEnvFeatureEnabled } from '@app/enviroment/enviroment';

// Off unless the deployment sets OFFICE_ADMIN_PRICING_ENABLED=true (ENABLE_OFFICE_ADMIN_PRICING on
// the backend, which defaults to off too): an env.js without the key hides the money.
export const isOfficeAdminPricingEnabled = (): boolean => isEnvFeatureEnabled('OFFICE_ADMIN_PRICING_ENABLED');

/**
 * Whether this user sees client-facing money: prices, totals, discounts, final prices and what is
 * owed. Only an office administrator on a deployment with the switch off does not; the backend
 * withholds the same fields from them everywhere except the service and package catalogue.
 */
export const canSeeClientPricing = (user: { isOfficeAdmin?: boolean; isAdmin?: boolean }): boolean =>
  !user.isOfficeAdmin || !!user.isAdmin || isOfficeAdminPricingEnabled();

// Sort and filter fields carrying client pricing, as column ids and as API fields.
const CLIENT_PRICING_QUERY_FIELDS = new Set([
  'price_total',
  'priceTotal',
  'discount_percent',
  'discountPercent',
  'price_final',
  'priceFinal',
  'finalPrice',
  'total_profit',
  'totalProfit',
  'payment',
]);

/**
 * A sort restored from storage, or a bookmarked filter, on a money column this user no longer sees
 * would be refused (403) and empty the whole list, with no header left to clear it. Drop them.
 */
export const withoutClientPricingSort = (sort: string, fallback: string): string =>
  sort
    .split(',')
    .filter((part) => !CLIENT_PRICING_QUERY_FIELDS.has(part.trim().replace(/^-/, '')))
    .join(',') || fallback;

export const withoutClientPricingFilters = (filters: Record<string, string>): Record<string, string> =>
  Object.fromEntries(
    Object.entries(filters).filter(
      ([key]) => !CLIENT_PRICING_QUERY_FIELDS.has(/^filter\[([^\]]+)\]/.exec(key)?.[1] ?? '')
    )
  );
